module.exports = __webpack_public_path__ + "img/fac2.cc205d82.png";